import React, {FC} from 'react';
import {Spinner} from 'react-bootstrap';
import {Sharing} from 'templates/reports/Sharing/mutation.sharing';
import {Toggle} from 'templates/reports/Sharing/Toggle';

import {useVisitors} from './mutation.visitors';

import * as styles from './styles.module.scss';

type StatusProps = {
	sharing: Sharing
	owner: boolean
}

export const Status: FC<StatusProps> = ({sharing, owner}) => {
	const {visitors} = useVisitors(sharing.cache);
	const message = () => {
		if (!sharing.enabled) {
			return 'Your report is private';
		} else if (visitors > 1) {
			return `Viewed by ${visitors.toLocaleString()} people`;
		}
		return 'Share your link to get started';
	};

	return (
		<div className={styles.status}>
			{owner ? (
				<div className={styles.toggle}>
					<Toggle
						open={sharing.enabled}
						onClick={sharing.toggle}
					/>
					Public sharing
					{sharing.loading && (
						<Spinner className={styles.spinner} />
					)}
				</div>
			) : (
				<div>
					You are viewing a shared BodySpec report.
				</div>
			)}
			<div className={styles.text}>
				{message()}
			</div>
		</div>
	);
};
